export interface ContactSubject {
    // Unique key used as the <Select> value. Two entries share the backend
    // subject `FAQ`, so we need a distinct id to render the right info box.
    id: string
    label: string
    // Value sent to the backend `subject` field (drives email routing).
    subject: string
    // Question slug, sent as `question`. Absent for the FAQ entries.
    question?: string
    // HTML rendered inside the info box.
    info: string
    // FAQ entries show the info box only — no form, no submit.
    displayForm: boolean
}

export const CONTACT_SUBJECTS: ContactSubject[] = [
    {
        id: "loan",
        label: "Assurance de prêt immobilier",
        subject: "QUESTION_LOAN",
        question: "question-pour-l-assurance-de-prt-immobilier",
        info: `Nous ferons tout pour vous répondre en moins de 24 heures. Si vous souhaitez un devis d'assurance emprunteur, vous pouvez utiliser notre <a href="/simulation-assurance-pret-immobilier">simulateur qui est gratuit et instantané</a>.`,
        displayForm: true,
    },
    {
        id: "faq-credit",
        label: "Crédit immobilier",
        subject: "FAQ",
        info: `Nous sommes spécialisés sur <a href="https://reassurez-moi.fr/simulation-assurance-pret-immobilier">l'assurance de prêt</a> et non le crédit immobilier.<br/><br/>En revanche, vous pouvez utiliser cet outil afin de <a href="https://reassurez-moi.fr/simulation-pret-immobilier">simuler votre prêt immobilier</a>.`,
        displayForm: false,
    },
    {
        id: "health",
        label: "Mutuelle Santé",
        subject: "QUESTION_HEALTH",
        question: "question-pour-la-mutuelle-sante",
        info: `Nous ferons tout pour vous répondre en moins de 24 heures. Si vous souhaitez un devis personnalisé de mutuelle santé, vous pouvez utiliser notre <a href="https://reassurez-moi.fr/comparateur-mutuelle-sante">simulateur qui est gratuit et instantané</a>.`,
        displayForm: true,
    },
    {
        id: "car",
        label: "Assurance Auto",
        subject: "QUESTION_CAR",
        question: "question-pour-l-assurance-auto",
        info: `Nous ferons tout pour vous répondre en moins de 24 heures. Si vous souhaitez un devis d'assurance auto, vous pouvez utiliser notre <a href="/comparateur-assurance-auto">comparateur qui est gratuit et instantané</a>.`,
        displayForm: true,
    },
    {
        id: "home",
        label: "Assurance habitation",
        subject: "QUESTION_HOME",
        question: "question-pour-l-assurance-habitation",
        info: `Nous ferons tout pour vous répondre en moins de 24 heures. Si vous souhaitez un devis d'assurance habitation, vous pouvez utiliser notre <a href="/comparateur-assurance-habitation">comparateur qui est gratuit et instantané</a>.`,
        displayForm: true,
    },
    {
        id: "pro",
        label: "Assurance professionnelle",
        subject: "QUESTION_PRO",
        question: "question-pour-l-assurance-professionnelle",
        info: `Nous sommes spécialisés sur l'assurance pour les particuliers. Si vous recherchez une assurance pour votre entreprise, nous vous conseillons <a rel="nofollow" href="https://app.coover.fr/mutuelle?utm_source=rm">le courtier d'assurances professionnelles Coover</a>.`,
        displayForm: true,
    },
    {
        id: "partnership",
        label: "Partenariat",
        subject: "QUESTION_PARTNERSHIP",
        question: "question-pour-un-partenariat",
        info: `Nous ferons tout pour vous répondre en moins de 24 heures.`,
        displayForm: true,
    },
    {
        id: "press",
        label: "Communication / Presse",
        subject: "QUESTION_PRESS",
        question: "communication-presse",
        info: `Nous ferons tout pour vous répondre en moins de 24 heures. Vous pouvez visiter <a href="https://reassurez-moi.fr/guide/communication">notre page presse ici.</a>`,
        displayForm: true,
    },
    {
        id: "faq-autre",
        label: "Autres assurances",
        subject: "FAQ",
        info: `Vous trouverez <a href="https://reassurez-moi.fr/">ici l'ensemble de nos comparateurs</a> pour avoir en quelques clics accès aux meilleures solutions d'assurance et à des avis d'experts indépendants.`,
        displayForm: false,
    },
]
